import React, { memo } from 'react';
import ThumbButton from './ThumbButton';
import classes from './ThumbButtonGroup.scss';
import { ThumbButtonGroupProps } from '../types.d';

const ThumbButtonGroup = ({
  label,
  onPositiveClick,
  onNegativeClick,
  isPositiveSelected,
  isNegativeSelected,
}: ThumbButtonGroupProps) => (
  <div className={classes.thumb_button_group}>
    <div className={classes.thumb_button_container}>
      <ThumbButton
        type="positive"
        isSelected={isPositiveSelected}
        onClick={onPositiveClick}
        position="left"
      />
      <ThumbButton
        type="negative"
        isSelected={isNegativeSelected}
        onClick={onNegativeClick}
        position="right"
      />
    </div>
    <div className={classes.thumb_button_label}>{label}</div>
  </div>
);

export default memo(ThumbButtonGroup);
